import {inject, injectable} from 'inversify';

import {ListDiaryEntriesQuery} from '../ports/ListDiaryEntries/ListDiaryEntries.query';

@injectable()
export class ListDiaryEntriesUseCase {
  constructor(
    @inject(ListDiaryEntriesQuery)
    private readonly query: ListDiaryEntriesQuery,
  ) {}

  async exec(
    props: ListDiaryEntriesUseCase.Props = {},
  ): Promise<ListDiaryEntriesUseCase.Response> {
    return this.query.exec(props);
  }
}

export namespace ListDiaryEntriesUseCase {
  export type Props = ListDiaryEntriesQuery.Props;
  export type Response = ListDiaryEntriesQuery.Response;
}
